'use client'

import type { AddressShippingSwitcherItemProps } from '@maestro/commerce-blocks/components/address-shipping-switcher/address-shipping-switcher.types'

import { SwitcherItem } from '@maestro/commerce-blocks/components/switcher'

export default function AddressShippingSwitcherItem(
  props: AddressShippingSwitcherItemProps
) {
  const { address, isSelected, isPending, isDisabled, onSelect } = props

  const description = [
    address.line1,
    [address.postalCode, address.town].filter(Boolean).join(' '),
  ]
    .filter(Boolean)
    .join('\n')

  return (
    <SwitcherItem
      name={address.name ?? ''}
      description={description}
      isSelected={isSelected}
      isPending={isPending}
      isDisabled={isDisabled}
      onSelect={onSelect}
    />
  )
}
